export { default as DynamicBG } from "./DynamicBG";
export { default as FormLogin } from "./FormLogin";
export { default as FormForgot } from "./FormForgot";
export { default as FormSignUp } from "./FormSignUp";
export { default as FormSignUpStep12 } from "./FormSignUpStep12";
export { default as FormSignUpStep13 } from "./FormSignUpStep13";
export { default as FormSignUpStep14 } from "./FormSignUpStep14";
export { default as FormSignUpComplement } from "./FormSignUpComplement";
export { default as StepBubbles } from "./StepBubbles";
export { default as AccountMain } from "./AccountMain";
export { default as AccountPersonal } from "./AccountPersonal";
export { default as AccountContact } from "./AccountContact";
export { default as FormUpdatePassword } from "./FormUpdatePassword";
export { default as ModalLogin } from "./ModalLogin";
export { default as ProductsModal } from "./ProductsModal";
export { default as Header } from "./Header";
export { default as Footer } from "./Footer";
export { default as ParticipationInfo } from "./ParticipationInfo";
export { default as CtaCards } from "./CtaCards";
export { default as FAQList } from "./FAQList";
export { default as FormInvoice } from "./FormInvoice";
export { default as QuestionModal } from "./QuestionModal";
export { default as WinnerModal } from "./WinnerModal";
export { default as FaileModal } from "./FaileModal";
export { default as ModalEmailSignUp } from "./ModalEmailSignUp";
export { default as CtaButtons } from "./CtaButtons";
export { default as HorizontalBrands } from "./HorizontalBrands";
export { default as ImgGirl } from "./ImgGirl"
export { default as Coupom } from "./Coupom"
export { default as PdfPreview } from "./PdfPreview"
export { default as ModalLGPD } from "./ModalLGPD"
export { default as PageViewTracker} from "./PageViewTracker"